const MODULE_NAME = 'JobsModule';

export const SET_CURRENT_JOB = `${MODULE_NAME}/SET_CURRENT_JOB`;
export const LOCAL_SET_CURRENT_JOB = 'SET_CURRENT_JOB';
export const SET_JOBS = `${MODULE_NAME}/SET_JOBS`;
export const SET_JOB_PROGRESS_TASKS = `${MODULE_NAME}/SET_JOB_PROGRESS_TASKS`;
export const UPSERT_REPAIR_ASSESSMENT_ROW = `${MODULE_NAME}/UPSERT_REPAIR_ASSESSMENT_ROW`;
export const DELETE_REPAIR_ASSESSMENT_ROW = `${MODULE_NAME}/DELETE_REPAIR_ASSESSMENT_ROW`;
export const SET_CURRENT_JOB_REPAIR_ASSESSMENT = `${MODULE_NAME}/SET_CURRENT_JOB_REPAIR_ASSESSMENT`;
export const MARK_FIELD_DIRTY = `${MODULE_NAME}/MARK_FIELD_DIRTY`;
export const CLEAR_DIRTY_FIELDS = `${MODULE_NAME}/CLEAR_DIRTY_FIELDS`;
export const DELETE_REPORT_REVISION = `${MODULE_NAME}/DELETE_REPORT_REVISION`;
export const UPDATE_FAVORITE_COUNT = `${MODULE_NAME}/UPDATE_FAVORITE_COUNT`;
export const SET_FAVOURITE_CURRENT_JOB = `${MODULE_NAME}/SET_FAVOURITE_CURRENT_JOB`;
